import { ReactElement, ReactNode } from 'react';

import { IconProps } from '@components/icons';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { Font } from '@styles/theme';

export type LabelTextGroupProps = {
  label: string | ReactNode;
  text?: string | string[];
  emptyText?: string;
  icon?: ReactElement<IconProps>;
  font?: Font;
};

export const LabelTextGroup = ({
  label,
  text,
  emptyText,
  icon,
  font = 'regular14',
}: LabelTextGroupProps) => {
  const { t } = useScopedTranslate(locale);
  const texts = Array.isArray(text) ? text : [text];
  const hasText = Boolean(text) && texts.length > 0;

  return (
    <Stack>
      <Stack space={1} orientation="horizontal" align="center">
        {icon}
        {typeof label == 'string' ? <Text font="semibold14" text={label} /> : label}
      </Stack>
      {hasText ? (
        texts.map((item, index) => <Text key={index} font={font} text={item} />)
      ) : (
        <Text font={font} color="purple50" text={emptyText ?? t('notSet')} />
      )}
    </Stack>
  );
};

const locale = {
  en: {
    notSet: 'Not set',
  },
};
